<script lang="ts">
  import { cn } from "@carto-au/svelte";
  import { format } from "date-fns";

  interface Props {
    date: Date;
    // Other attrs
    [attr: string]: unknown;
  }

  const { date, ...attrs }: Props = $props();
</script>

<time
  {...attrs}
  datetime={format(date, "yyyy-MM-dd")}
  class={cn("whitespace-nowrap", attrs.class)}
>
  {format(date, "d MMM yyyy")}
</time>
